import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _readOnlyError from "@babel/runtime-corejs3/helpers/readOnlyError";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["render", "children", "multiple"];
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
//@ts-nocheck
import Downshift from "downshift";
import React from "react";

// Handles multiple and non-multiple downshift cases
// most code is https://codesandbox.io/s/github/kentcdodds/downshift-examples/tree/master/?module=%2Fsrc%2Fordered-examples%2F04-multi-select.js&moduleview=1
import { jsx as _jsx } from "react/jsx-runtime";
var MultiDownshift = /*#__PURE__*/function (_React$Component) {
  function MultiDownshift(props) {
    var _this;
    _classCallCheck(this, MultiDownshift);
    _this = _callSuper(this, MultiDownshift, [props]);
    _defineProperty(_this, "downshift", null);
    _defineProperty(_this, "clear", function () {
      _this.downshift.clearSelection();
      _this.setState({
        selectedItems: _this.props.multiple ? [] : null
      });
    });
    _defineProperty(_this, "stateReducer", function (state, changes) {
      switch (changes.type) {
        case Downshift.stateChangeTypes.keyDownEnter:
        case Downshift.stateChangeTypes.clickItem:
          return _objectSpread(_objectSpread({}, changes), {}, {
            highlightedIndex: state.highlightedIndex,
            isOpen: true,
            inputValue: ""
          });
        default:
          return changes;
      }
    });
    _defineProperty(_this, "callOnChange", function () {
      var onChange = _this.props.onChange;
      var selectedItems = _this.state.selectedItems;
      if (onChange) {
        onChange(selectedItems);
      }
    });
    _defineProperty(_this, "handleSelection", function (selectedItem) {
      var _context;
      if (_includesInstanceProperty(_context = _this.state.selectedItems).call(_context, selectedItem)) {
        _this.removeItem(selectedItem);
      } else {
        _this.addSelectedItem(selectedItem);
      }
    });
    _defineProperty(_this, "removeItem", function (item) {
      _this.setState(function (_ref) {
        var selectedItems = _ref.selectedItems;
        return {
          selectedItems: _filterInstanceProperty(selectedItems).call(selectedItems, function (i) {
            return i !== item;
          })
        };
      }, _this.callOnChange);
    });
    var _state = {
      selectedItems: []
    };
    if (props.initialSelectedItem) {
      _state.selectedItems = props.initialSelectedItem;
    }
    _this.state = _state;
    return _this;
  }
  _inherits(MultiDownshift, _React$Component);
  return _createClass(MultiDownshift, [{
    key: "addSelectedItem",
    value: function addSelectedItem(item) {
      this.setState(function (_ref2) {
        var _context2;
        var selectedItems = _ref2.selectedItems;
        return {
          selectedItems: _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(selectedItems), [item])
        };
      }, this.callOnChange);
    }
  }, {
    key: "getStateAndHelpers",
    value: function getStateAndHelpers(downshift) {
      var selectedItems = this.state.selectedItems;
      var removeItem = this.removeItem;
      return _objectSpread({
        removeItem: removeItem,
        selectedItems: selectedItems
      }, downshift);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        render = _this$props.render,
        _this$props$children = _this$props.children,
        _children = _this$props$children === void 0 ? render : _this$props$children,
        multiple = _this$props.multiple,
        props = _objectWithoutProperties(_this$props, _excluded);
      if (multiple) {
        return /*#__PURE__*/_jsx(Downshift, _objectSpread(_objectSpread({}, props), {}, {
          stateReducer: this.stateReducer,
          onChange: this.handleSelection,
          selectedItem: null,
          children: function children(downshift) {
            _this2.downshift = downshift;
            return _children(_this2.getStateAndHelpers(downshift));
          }
        }));
      }

      // single-selection use case
      return /*#__PURE__*/_jsx(Downshift, _objectSpread(_objectSpread({}, props), {}, {
        children: function children(downshift) {
          _this2.downshift = downshift;
          return _children(_this2.getStateAndHelpers(downshift));
        }
      }));
    }
  }]);
}(React.Component);
export { MultiDownshift as default };